/**
 * form-grid-container.js
 */

import React from 'react';
import { Grid } from '@mui/material';


import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  grid: {
    paddingRight: 36,
    '.MuiAccordionSummary-content &': {
      paddingRight: 0
    }
  }
}));


export default function FormGridContainer(props) { 
  const {
    direction,
    columnSpacing = 2,
    rowSpacing = 2,
    ...rest
  } = props;
  const classes = useStyles();

  return (
    <Grid 
      container 
      columnSpacing={columnSpacing}
      rowSpacing={rowSpacing}
      className={classes.grid}
      // Passing direction to Grid will cause it to ignore item widths, 
      // which is not what we want, so set it here instead.
      style={{flexDirection: direction}}
      {...rest} 
    />
  );
}